class Page {
    // Check if page is active
    is(slug) {
        // Returns true or false
        return $('body').hasClass(`page-${ slug }`);
    }

    in(slugs) {
        // Make sure slugs is an array
        slugs = slugs instanceof Array ? slugs : [slugs];

        return slugs.find((slug) => this.is(slug));
    }

    segment(id) {
        // Get segments
        const segments = window.location.pathname.split('/');
        // If segment is set
        if (segments[id] != null) {
            // Return requested segment
            return segments[id];
        }

        return false;
    }

    segmentMatch(id, match) {
        // Shorthand segment check
        return this.segment(id) === match;
    }
}

export default Page;
